import _ from 'lodash';
//import { createReducer } from './utility';

export const SAVING_EVENT = 'general/SAVING_EVENT';
export const SUCCESS_EVENT = 'general/SUCCESS_EVENT';
export const ERROR_EVENT = 'general/ERROR_EVENT';
export const CLEAR_ERROR = 'general/CLEAR_ERROR';
export const CLEAR_SUCCESS = 'general/CLEAR_SUCCESS';
export const CLEAR_SAVING = 'general/CLEAR_SAVING';

const initialState = {};

//- Reducers
export default (state = initialState, action) => {
	switch (action.type) {
		case SAVING_EVENT:
			return {
				...state,
				savingMessage: action.savingMessage,
				savingStatus: 'saving',
			};

		case SUCCESS_EVENT:
			return {
				...state,
				successMessages: action.successMessages,
				onSuccessRedirectTo: action.onSuccessRedirectTo,
			};

		case ERROR_EVENT:
			return {
				...state,
				errorMessages: action.errorMessages,
			};
		case CLEAR_ERROR:
			return {
				...state,
				errorMessages: undefined,
			};

		case CLEAR_SUCCESS:
			return {
				...state,
				successMessages: undefined,
			};
		default:
			return state;
	}
};

export const showErrors = (errors) => {
	return (dispatch) => {
		dispatch({
			type: ERROR_EVENT,
			errorMessages: _.isArray(errors) ? errors : [errors],
		});
	};
};

export const clearError = () => {
	return (dispatch) => {
		dispatch({
			type: CLEAR_ERROR,
		});
	};
};
export const clearSuccess = () => {
	return (dispatch) => {
		dispatch({
			type: CLEAR_SUCCESS,
		});
	};
};
export const clearSaving = () => {
	return (dispatch) => {
		dispatch({
			type: CLEAR_SAVING,
		});
	};
};
